const deepCopy = obj =>
  Object.entries(obj).reduce((acc, [key, value]) => {
    if (typeof value === "object") {
      acc[key] = deepCopy(value);
    } else {
      acc[key] = value;
    }
    return acc;
  }, {});

const fileDownload = (blob, fileName) => {
  if (typeof window.navigator.msSaveBlob !== "undefined") {
    window.navigator.msSaveBlob(blob, fileName);
  } else {
    const blobURL = window.URL.createObjectURL(blob);
    const tempLink = document.createElement("a");
    tempLink.style.display = "none";
    tempLink.href = blobURL;
    tempLink.setAttribute("download", fileName);
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(blobURL);
  }
};

const objectEmptyStringsToNull = obj =>
  Object.assign(
    ...Object.keys(obj).map(key => ({
      [key]: obj[key] !== "" ? obj[key] : null
    }))
  );

const arrayCount = array => {
  if (array && Array.isArray(array)) {
    return array.length;
  }
  return 0;
};

const hasProperty = (obj, key) => {
  return !!obj && Object.prototype.hasOwnProperty.call(obj, key);
};

const decodeJwt = token => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  return JSON.parse(decodeURIComponent(escape(window.atob(base64))));
};

/**
 * "文字列の日付+時間"を"文字列の日付"へ変換する
 * @param datetimeStr "xxxx/xx/xx yy:yy:yy.yyy"で表されたの日時
 */
const convertDatetimeStrToDateStr = datetimeStr => {
  const datetime = new Date(datetimeStr);
  return `${datetime.getFullYear()}/${("0" + (datetime.getMonth() + 1)).slice(
    -2
  )}/${("0" + datetime.getDate()).slice(-2)}`;
};

/**
 * nullまたはundefinedの場合、空文字を返却する
 * @param value
 * @returns {string|*}
 */
const nullToEmpty = value => {
  if (value === null) {
    return "";
  }
  if (typeof value === "undefined") {
    return "";
  }
  return value;
};

/**
 * 空文字、null、undefinedのチェック（true：空文字/null/undefined、false：空文字/null/undefined以外）
 * @param value
 * @returns {string|*}
 */
const nullCheck = value => {
  if (value === null) {
    return true;
  }
  if (typeof value === "undefined") {
    return true;
  }
  if (value === "") {
    return true;
  }
  return false;
};

/**
 * 乱数生成（半角英字・半角数字）
 * @param {*} length 文字列長
 */
const makeRandom = length => {
  const chracter =
    "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let chracterLength = chracter.length;
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chracter[Math.floor(Math.random() * chracterLength)];
  }
  return result;
};

export {
  deepCopy,
  fileDownload,
  objectEmptyStringsToNull,
  arrayCount,
  hasProperty,
  decodeJwt,
  convertDatetimeStrToDateStr,
  nullToEmpty,
  makeRandom,
  nullCheck
};
